import React, { useState } from 'react';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthAPI } from '../api/authApi';
import styles from './login.module.scss';
import useToast from '../../../shared/hooks/useToast';
import AuthSplitLayout from '../components/AuthSplitLayout';
import PinInput from '../components/PinInput';
import {
  ADMIN_PIN_LENGTH,
  ADMIN_PIN_PATTERN,
} from '../../admins/utils/adminUsername';

// Stranica iz mejla "Zaboravljen PIN" (samo super admin): /novi-pin?token=...
// Link vazi 30 minuta i moze se iskoristiti samo jednom.
const ResetPin = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [pin, setPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [resetKey, setResetKey] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e?.preventDefault?.();

    if (!ADMIN_PIN_PATTERN.test(pin)) {
      setError(`PIN mora imati tačno ${ADMIN_PIN_LENGTH} cifara.`);
      return;
    }
    if (pin !== confirmPin) {
      setError('PIN-ovi se ne poklapaju.');
      return;
    }

    setError('');
    setLoading(true);
    const { ok, message } = await AuthAPI.resetPin({ token, pin });
    setLoading(false);

    if (!ok) {
      setError(message);
      setPin('');
      setConfirmPin('');
      setResetKey((key) => key + 1);
      return;
    }

    toast.success(message);
    navigate('/login', { replace: true });
  };

  return (
    <AuthSplitLayout>
      <div className={styles.enterLeft}>
        <h1 className={styles.login__title}>Novi PIN</h1>
        {token ? (
          <>
            <p className={styles.login__subtitle}>
              Unesite novi PIN od {ADMIN_PIN_LENGTH} cifara za svoj nalog.
            </p>

            <form className={styles.login__form} onSubmit={handleSubmit}>
              <div className={styles.login__field}>
                <span id="new-pin-label" className={styles.login__label}>
                  Novi PIN
                </span>
                <PinInput
                  labelId="new-pin-label"
                  onChange={setPin}
                  resetKey={`new-${resetKey}`}
                />
              </div>

              <div className={styles.login__field}>
                <span id="confirm-pin-label" className={styles.login__label}>
                  Ponovite PIN
                </span>
                <PinInput
                  labelId="confirm-pin-label"
                  onChange={setConfirmPin}
                  resetKey={`confirm-${resetKey}`}
                />
              </div>

              {error && <div className={styles.login__error}>{error}</div>}

              <Button
                type="primary"
                htmlType="submit"
                block
                loading={loading}
                className={styles.login__submit}
              >
                Sačuvaj PIN
              </Button>
            </form>
          </>
        ) : (
          <div className={styles.login__error}>
            Link nije ispravan. Zatražite novi preko „Zaboravili ste PIN?“ na
            prijavi.
          </div>
        )}

        <button
          type="button"
          className={styles.login__back}
          onClick={() => navigate('/login')}
        >
          <ArrowLeftOutlined />
          Nazad na prijavu
        </button>
      </div>
    </AuthSplitLayout>
  );
};

export default ResetPin;
